import hoistNonReactStatic from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';
import {useStore} from 'react-redux';
import {Store} from 'redux';

import {getDisplayName} from 'src/js/common/utils/component_utils';

export interface InjectStoreExtraProps {
  store: Store;
}

function injectStore<P>(
  WrappedComponent: React.ComponentType<P & InjectStoreExtraProps>
) {
  const InjectStore = (props: P) => {
    const store = useStore();

    return <WrappedComponent store={store} {...props} />;
  };

  InjectStore.displayName = `InjectStore(${getDisplayName(WrappedComponent)})`;
  InjectStore.WrappedComponent = WrappedComponent;

  InjectStore.contextTypes = {
    store: PropTypes.objectOf(PropTypes.any),
  };

  hoistNonReactStatic(InjectStore, WrappedComponent);

  return InjectStore;
}

export default injectStore;
